import { render, staticRenderFns } from "./UpdateUploadDocument.vue?vue&type=template&id=720a7cb3&scoped=true&"
import script from "./UpdateUploadDocument.vue?vue&type=script&lang=js&"
export * from "./UpdateUploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUploadDocument.vue?vue&type=style&index=0&id=720a7cb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a7cb3",
  null
  
)

export default component.exports